import {
  Box,
  IconButton,
  Link,
  Typography,
  styled,
  useTheme,
} from "@mui/material";

import React from "react";

import { Fullscreen, Settings } from "@mui/icons-material";
import { openFullscreen } from "data/functions";
import { useNavigate } from "react-router-dom";
import { MainBody } from "./MainBody";

const Root = styled("div")(({ theme }) => ({
  background: "transparent",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  //https://colorgradient.dev/gradient-generator/
  // backgroundColor: grey[100],
  position: "relative",
}));

function MainPage(props) {
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <Root>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          top: "2px",
          width: "100%",
        }}
      >
        <IconButton onClick={() => navigate("settings")}>
          <Settings sx={{ fill: theme?.palette?.action?.selected }} />
        </IconButton>
        <IconButton onClick={() => openFullscreen()}>
          <Fullscreen sx={{ fill: theme?.palette?.action?.selected }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          overflow: "auto",
        }}
      >
        <MainBody />
      </Box>
    </Root>
  );
}

export default MainPage;
